
export const isInRange = (
    amount : number,
    from : number,
    to: number | undefined
    ) =>
    {
        if(to == null){
            return from < amount;
        }
        return from <= amount && amount < to;
    }

